import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import Title from "../layouts/Title";
import ContactLeft from "./ContactLeft";

const Contact = () => {
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [status, setStatus] = useState({ type: "", message: "" });

  const handleSend = (e) => {
    e.preventDefault();

    if (!username || !email || !subject || !message) {
      setStatus({
        type: "error",
        message: "❌ Please fill all required fields",
      });
      return;
    }

    const templateParams = {
      name: username,
      email: email,
      phone: phoneNumber,
      subject: subject,
      message: message,
    };

    emailjs
      .send(
        "service_oic6pzr",
        "template_2esbnqt",
        templateParams,
        "ToMwD2U-MMrJCPgCZ"
      )
      .then(
        () => {
          setStatus({
            type: "success",
            message: "✅ Message sent successfully!",
          });

          setUsername("");
          setPhoneNumber("");
          setEmail("");
          setSubject("");
          setMessage("");
        },
        () => {
          setStatus({
            type: "error",
            message: "❌ Failed to send message",
          });
        }
      );
  };

  const inputStyle = `
    w-full
    bg-gradient-to-r from-bodyColor to-[#202327]
    text-gray-300
    rounded-lg px-4 py-3
    border border-gray-600/60
    outline-none
    transition-all duration-300
    focus:border-designColor/60
    focus:ring-0
    focus:shadow-[0_0_14px_rgba(255,0,79,0.35)]
  `;

  return (
    <section id="contact" className="w-full py-20 border-b border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact With Me" />
      </div>

      <div className="w-full flex flex-col lgl:flex-row gap-10 mt-10">
        {/* Left Card */}
        <ContactLeft />

        {/* Right Form Card */}
        <div
          className="
            flex-1 relative overflow-hidden
            bg-gradient-to-r from-bodyColor to-[#202327]
            p-6 lgl:p-10
            rounded-2xl
            border border-gray-800
            shadow-shadowOne
            transition-all duration-300
            hover:-translate-y-1
            hover:border-designColor/40
            hover:shadow-[0_0_30px_rgba(255,0,79,0.18)]
          "
        >
          <form onSubmit={handleSend} className="flex flex-col gap-5">
            {/* Status Message */}
            {status.message && (
              <p
                className={`text-center text-sm font-medium ${
                  status.type === "success"
                    ? "text-green-400"
                    : "text-red-400"
                }`}
              >
                {status.message}
              </p>
            )}

            <input
              type="text"
              placeholder="Your Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className={inputStyle}
              required
            />

            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputStyle}
              required
            />

            <input
              type="text"
              placeholder="Phone (optional)"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className={inputStyle}
            />

            <input
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className={inputStyle}
              required
            />

            <textarea
              rows="6"
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className={inputStyle}
              required
            />

            <button
              type="submit"
              className="
                w-full h-12
                bg-gradient-to-r from-bodyColor to-[#202327]
                rounded-lg
                text-gray-400
                border border-gray-600/60
                transition-all duration-300
                hover:text-white
                hover:border-designColor/60
                hover:-translate-y-0.5
                hover:shadow-[0_0_20px_rgba(255,0,79,0.45)]
              "
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
